module.exports = __webpack_public_path__ + "img/TCR.cd9046f1.png";